import { Line } from "react-chartjs-2"
import { Box, CircularProgress, Paper, Typography } from "@mui/material"
import { getTrendData } from "routes/sfg20-admin/plugins/system-info/usage-trends-tab/controller/get-trend-data"
import uniqolor from "uniqolor"

export function StandardTimeSeriesGraph({ measure, title }) {
    const data = getTrendData.useResults(measure)

    const sx = {
        width: "100%", // Ensures it fills the Grid item
        height: "250px", // Fixed height for uniformity
        padding: 10,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center", // Centers everything inside
        borderRadius: 5,
    }

    if (!data) {
        return (
            <Paper elevation={3} sx={sx}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                    <CircularProgress />
                </Box>
                <Typography mt={4} variant="subtitle1" sx={{ width: "100%", textAlign: "center", marginBottom: 2 }}>
                    {title}
                </Typography>
            </Paper>
        )
    }

    const sortedData = [...data.results].sort((a, b) => new Date(a.created) - new Date(b.created))

    // Convert each item to a data point with x (time) and y (value).
    const dataPoints = sortedData.map((item) => ({
        x: new Date(item.created),
        y: item.value,
    }))

    // Compute min and max dates for the x-axis.
    const dates = sortedData.map((item) => new Date(item.created))
    const minDate = new Date(Math.min(...dates))
    const maxDate = new Date(Math.max(...dates))

    const { color } = uniqolor(title.trimEnd(), {
        saturation: [65, 99],
        lightness: [65, 87],
    })
    const chartData = {
        datasets: [
            {
                label: title,
                data: dataPoints,
                borderColor: color, // Line color
                backgroundColor: `${color}80`, // 50% opacity for fill (RGBA hex)
                fill: true, // Enables filled area under the line
                tension: 0.3,
            },
        ],
    }

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false, // Hides the legend
            },
        },
        scales: {
            x: {
                type: "time",
                time: {
                    unit: "day",
                },
                min: minDate,
                max: maxDate,
            },
            y: {
                beginAtZero: true,
            },
        },
    }

    return (
        <Paper elevation={3} style={sx}>
            <Line data={chartData} options={options} />
            <Typography mt={2} variant="subtitle1" sx={{ width: "100%", textAlign: "center", marginBottom: 2 }}>
                {title}
            </Typography>
        </Paper>
    )
}
